import React from "react";
import { useNavigate } from "react-router-dom";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import {
  ReportContainer,
  FilterHeader,
  ChartMainWrapper,
  MobileFB,
} from "pages/FoodAndBeverages/F&BReports/F&BReportsStyled";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useState } from "react";
import moment from "moment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import UncheckIcon from "assets/svgIcons/UncheckIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import { ClickAwayListener } from "@mui/base";
import { Tooltip } from "@mui/material";
import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesDefaults,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
} from "@progress/kendo-react-charts";
import "hammerjs";
import accounting from "accounting-js";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useTranslation } from "react-i18next";
import { featureKey } from "constant";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";

function FBReports() {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const {
    getFoodOrdersDataState,
    getFoodOrdersDataStatus,
    siteSettingsData,
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
  } = useSelector((state) => state?.commonReducers) || [];

  const { FoodBevEnabled } = siteSettingsData;
  const [isFoodEnable, setIsFoodEnable] = useState(FoodBevEnabled);

  async function handleOnChange(e) {
    let payload = e.target.checked;
    setIsFoodEnable(payload);
    await dispatch(COMMON_SERVICES.putFoodEnabledService(siteId.get(), payload));
  }

  const [salesByItemChartData, setSalesByItemChartData] = useState([]);
  const [salesByDateChartData, setSalesByDateChartData] = useState({});
  const [sellersByTotalSales, setSellersByTotalSales] = useState({});
  const [sellersByQuantity, setSellersByQuantity] = useState({});
  const [pieChartRefreshState, setPieChartRefreshState] = useState(true);
  const [reloadState, setReloadState] = useState(true);
  const [disabledButton, setDisabledButton] = useState(false);
  const [outsideClick, setOutsideClick] = useState(false);
  const [outsideClick1, setOutsideClick1] = useState(false);
  const [startDate, setStartDate] = useState(
    localStorage.getItem("foodReportStartDate") !== null
      ? new Date(localStorage.getItem("foodReportStartDate"))
      : new Date()
  );
  const [endDate, setEndDate] = useState(
    localStorage.getItem("foodReportEndDate") !== null
      ? new Date(localStorage.getItem("foodReportEndDate"))
      : new Date()
  );
  const [MtdState, setMtdState] = useState(false);
  const [QtdState, setQtdState] = useState(false);
  const [YTDState, setYTDState] = useState(false);

  const [startDateColor, setStartDateColor] = useState("#000");
  const [endDateColor, setEndDateColor] = useState("#000");

  useEffect(() => {
    if(Object.keys(siteSettingsData).length > 0) {
      if(!siteSettingsData?.Features?.includes(featureKey.golf)) {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    setIsFoodEnable(FoodBevEnabled);
  }, [FoodBevEnabled]);

  useEffect(() => {
    if (Object.keys(siteSettingsData)?.length !== 0 && reloadState) {
      dispatch(
        COMMON_SERVICES.getFoodOrdersDataServices(
          setDateToLocalMidnightUTC(new Date(startDate)),
          setDateToLocalMidnightUTC(new Date(endDate)),
          siteId.get()
        )
      );
      setReloadState(false);
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (!reloadState) {
      setReloadState(true);
    }
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    if (startDate == null && endDate == null) {
      localStorage.setItem("foodReportStartDate", new Date());
      localStorage.setItem("foodReportEndDate", new Date());
      setStartDate(new Date());
      setEndDate(new Date());
    } else if (startDate === null) {
      localStorage.setItem("foodReportStartDate", new Date());
      setStartDate(new Date());
    } else if (endDate === null) {
      localStorage.setItem("foodReportEndDate", new Date());
      setStartDate(new Date());
    }
  }, []);

  useEffect(() => {
    if (
      siteSettingsData &&
      Object.keys(siteSettingsData).length !== 0 &&
      getFoodOrdersDataState &&
      Object.keys(getFoodOrdersDataState).length !== 0
    ) {
      setPieChartRefreshState(true);
      setTimeout(() => setPieChartRefreshState(false), 2000);
      showSalesByItem();
      showTopItems();
      showSalesByDate();
    }
  }, [getFoodOrdersDataState]);

  useEffect(() => {
    setPieChartRefreshState(false);
  }, [
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
    startDate,
    endDate,
    siteSettingsData,
  ]);

  useEffect(() => {
    if (startDate > endDate) {
      localStorage.setItem("foodReportEndDate", new Date(startDate));
      setEndDate(startDate);
      setEndDateColor("#ff0000");
    }
  }, [startDate]);

  useEffect(() => {
    if (startDate > endDate) {
      localStorage.setItem("foodReportStartDate", new Date(endDate));
      setStartDate(endDate);
      setStartDateColor("#ff0000");
    }
  }, [endDate]);

  let maxSlices = 20;

  function showSalesByItem() {
    if (
      getFoodOrdersDataState &&
      Object.keys(getFoodOrdersDataState).length !== 0
    ) {
      let tempsalesByItemData = JSON.parse(
        JSON.stringify(getFoodOrdersDataState?.SalesByItem)
      );
      tempsalesByItemData.sort(function (a, b) {
        return a?.ExtPrice < b?.ExtPrice
          ? 1
          : a?.ExtPrice > b?.ExtPrice
            ? -1
            : 0;
      });

      let data = [];
      let limit =
        tempsalesByItemData?.length <= maxSlices
          ? tempsalesByItemData?.length
          : maxSlices;
      for (let i = 0; i < limit; i++) {
        data.push({
          category: tempsalesByItemData[i]?.Description,
          value: tempsalesByItemData[i]?.ExtPrice,
        });
      }
      if (limit < tempsalesByItemData.length) {
        let sum = 0;
        for (let i = limit; i < tempsalesByItemData.length; i++) {
          sum += tempsalesByItemData[i]?.ExtPrice;
        }
        data.push({ category: "Other", value: sum });
      }

      setSalesByItemChartData(data);
    }
  }

  function showSalesByDate() {
    if (
      getFoodOrdersDataState &&
      Object.keys(getFoodOrdersDataState).length !== 0 &&
      Object.keys(getFoodOrdersDataState?.SalesByDate).length !== 0
    ) {
      let values = [];
      let labels = [];
      let title = null;
      let yaxis = null;
      let format = "DD-MMM-YY";

      switch (getFoodOrdersDataState?.SalesByDate?.DateGrouping) {
        case "d":
          title = t("Sales_by_Day");
          break;
        case "w":
          title = t("Sales_by_Week");
          break;
        case "m":
          title = t("Sales_by_Month");
          format = "MMM-YY";
          break;
      }

      for (
        let i = 0;
        i < getFoodOrdersDataState?.SalesByDate?.OrdersTotals.length;
        i++
      ) {
        values.push(
          getFoodOrdersDataState?.SalesByDate?.OrdersTotals[i]?.TotalSales
        );
        //convert date back to timezone for display
        let tempDate = moment(
          getFoodOrdersDataState?.SalesByDate?.OrdersTotals[i]?.Date
        );
        tempDate.utcOffset(-siteSettingsData?.TimeZoneOffset);
        tempDate = tempDate.format(format);
        labels.push(tempDate);
      }
      setSalesByDateChartData({
        title: title,
        labels: labels,
        values: values,
      });
    }
  }

  function showTopItems() {
    if (
      getFoodOrdersDataState &&
      Object.keys(getFoodOrdersDataState).length !== 0
    ) {
      let tempsalesByItemData = JSON.parse(
        JSON.stringify(getFoodOrdersDataState?.SalesByItem)
      );

      // By total sales of each item
      tempsalesByItemData.sort(function (a, b) {
        return a?.ExtPrice < b?.ExtPrice
          ? 1
          : a?.ExtPrice > b?.ExtPrice
            ? -1
            : 0;
      });
      let values = [];
      let labels = [];
      for (let i = 0; i < tempsalesByItemData.length && i < 10; i++) {
        values.push(tempsalesByItemData[i]?.ExtPrice);
        labels.push(tempsalesByItemData[i]?.Description);
      }
      setSellersByTotalSales({
        title: t("Top_Sellers_by_Total_Sales"),
        labels: labels,
        values: values,
      });
      // By quantity of each item
      tempsalesByItemData.sort(function (a, b) {
        return a?.Quantity < b?.Quantity
          ? 1
          : a?.Quantity > b?.Quantity
            ? -1
            : 0;
      });
      values = [];
      labels = [];
      for (var i = 0; i < tempsalesByItemData.length && i < 10; i++) {
        values.push(tempsalesByItemData[i]?.Quantity);
        labels.push(tempsalesByItemData[i]?.Description);
      }
      setSellersByQuantity({
        title: t("Top_Sellers_by_Quantity"),
        labels: labels,
        values: values,
      });
    }
  }

  const labelContent = (props) => {
    let formatedNumber = Number(props.dataItem.value).toLocaleString(
      undefined,
      {
        style: "percent",
        minimumFractionDigits: 2,
      }
    );
    return `${props.dataItem.category}`;
  };

  function handleCurrencyFormat(value) {
    return accounting
      .formatMoney(value, {
        symbol: siteSettingsData?.CurrencySymbol,
        precision: 2,
        thousand: siteSettingsData?.CurrencyThousandsSeparator,
        decimal: siteSettingsData?.CurrencyDecimalSeparator,
      })
      .toString();
  }

  const nestedTooltipRender = ({ point }) => {
    let data = handleCurrencyFormat(point?.value);

    return (
      <span>
        <b> {data}</b>
      </span>
    );
  };

  const sellersTooltipRender = ({ point }) => {
    let data = accounting
      .formatMoney(point?.value, {
        symbol: siteSettingsData?.CurrencySymbol,
        precision: 2,
        thousand: siteSettingsData?.CurrencyThousandsSeparator,
        decimal: siteSettingsData?.CurrencyDecimalSeparator,
      })
      .toString();

    return (
      <span>
        <b> {data}</b>
      </span>
    );
  };

  const tempSellersTooltipRender = (e) => {
    return accounting
      .formatMoney(e?.value, {
        symbol: siteSettingsData?.CurrencySymbol,
        precision: 0,
        thousand: siteSettingsData?.CurrencyThousandsSeparator,
        decimal: siteSettingsData?.CurrencyDecimalSeparator,
      })
      .toString();
  };

  const quantityTooltipRender = ({ point }) => {
    let data = point?.value;

    return (
      <span>
        <b> {data}</b>
      </span>
    );
  };

  const handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    if (pieChartRefreshState) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  function datesMatch(date1, date2) {
    let m1 = moment(date1).format("YYYY-MM-DD");
    let m2 = moment(date2).format("YYYY-MM-DD");
    return m1 === m2;
  }

  // Set date range to "year to date"
  function setYTD() {
    let jan1 = new Date();
    jan1.setMonth(0);
    jan1.setDate(1);

    setDateRange(jan1, new Date());
    setPieChartRefreshState(false);
    setYTDState(true);

    setQtdState(false);
    setMtdState(false);
  }

  // Set date range to "quarter to date"
  function setQTD() {
    let d1 = new Date();
    let m = Math.floor(d1.getMonth() / 3);
    d1.setMonth(m * 3);
    d1.setDate(1);
    setDateRange(d1, new Date());
    setPieChartRefreshState(false);
    setQtdState(true);

    setYTDState(false);
    setMtdState(false);
  }

  // Set date range to "month to date"
  function setMTD() {
    let d1 = new Date();
    d1.setDate(1);
    setDateRange(d1, new Date());
    setPieChartRefreshState(false);
    setMtdState(true);

    setQtdState(false);
    setYTDState(false);
  }

  function setDateRange(start, end) {
    if (!datesMatch(start, new Date(startDate))) {
      localStorage.setItem("foodReportStartDate", new Date(start));
      setStartDate(start);
    }
    if (!datesMatch(end, new Date(endDate))) {
      localStorage.setItem("foodReportEndDate", new Date(end));
      setEndDate(end);
    }

    if (
      !datesMatch(start, new Date(startDate)) &&
      !datesMatch(end, new Date(endDate))
    ) {
      localStorage.setItem("foodReportStartDate", new Date(start));
      localStorage.setItem("foodReportEndDate", new Date(end));
      setStartDate(start);
      setEndDate(end);
    }
  }

  function setDateToLocalMidnightUTC(dateToSet) {
    if (dateToSet !== null) {
      let returnDate = moment();

      returnDate.utcOffset(-siteSettingsData?.TimeZoneOffset);
      returnDate
        .year(dateToSet.getFullYear())
        .month(dateToSet.getMonth())
        .date(dateToSet.getDate())
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);
      returnDate = returnDate.toISOString();

      return returnDate;
    } else {
      return null;
    }
  }

  function handleRefresh() {
    dispatch(
      COMMON_SERVICES.getFoodOrdersDataServices(
        setDateToLocalMidnightUTC(new Date(startDate)),
        setDateToLocalMidnightUTC(new Date(endDate)),
        siteId.get()
      )
    );
    setStartDateColor("#000");
    setEndDateColor("#000");
  }

  const activeBtn = {
    background: "#BC9B6A",
    color: "#fff",
    borderColor: "#BC9B6A",
  };

  useEffect(() => {
    if (MtdState || QtdState || YTDState) setStartDateColor("#ff0000");
    // setStartDateColor("#ff0000")
  }, [startDate]);

  useEffect(() => {
    if (MtdState || QtdState || YTDState) setEndDateColor("#ff0000");
    // setEndDateColor("#ff0000")
  }, [endDate]);

  return (
    <>
      <ReportContainer>
        <FilterHeader>
          <div className="label-wrapper">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <label htmlFor="">{t("Start")}</label>
              <ClickAwayListener
                onClickAway={() => {
                  if (outsideClick) {
                    setStartDate(new Date(startDate));
                    setDisabledButton(false);
                    setOutsideClick(false);
                  }
                }}
              >
                <DatePicker
                  value={startDate}
                  inputFormat="DD-MMM-YYYY"
                  onChange={(newValue) => {
                    if (newValue && newValue.format() !== "Invalid Date") {
                      localStorage.setItem(
                        "foodReportStartDate",
                        new Date(newValue)
                      );
                      setStartDate(newValue);
                      setDisabledButton(false);
                    } else {
                      if (newValue === null) {
                        // let sDateData = new Date(
                        //   localStorage.getItem("foodReportStartDate")
                        // );
                        // setStartDate(sDateData);
                        setDisabledButton(true);
                        setOutsideClick(true);
                      } else {
                        setDisabledButton(true);
                      }
                    }
                    setStartDateColor("#ff0000");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        input: { color: startDateColor },
                      }}
                    />
                  )}
                  PaperProps={{
                    sx: {
                      maxHeight: 350,
                      "& .MuiPickersLayout-contentWrapper": {
                        mb: 0,
                      }
                    }
                  }}
                  components={{
                    ActionBar: (props) => (
                      <TodayDateActionBar
                        onToday={() => {
                          const today = moment().startOf("day");
                          if (today && today.format() !== "Invalid Date") {
                            localStorage.setItem(
                              "foodReportStartDate",
                              new Date(today)
                            );
                            setStartDate(today);
                            setDisabledButton(false);
                            props.onAccept?.();
                            props.onClose?.();
                          } else {
                            if (today === null) {
                              // let sDateData = new Date(
                              //   localStorage.getItem("foodReportStartDate")
                              // );
                              // setStartDate(sDateData);
                              setDisabledButton(true);
                              setOutsideClick(true);
                            } else {
                              setDisabledButton(true);
                            }
                          }
                          setStartDateColor("#ff0000");
                        }}
                      />
                    ),
                  }}
                />
              </ClickAwayListener>

              <label htmlFor="">{t("End")}</label>
              <ClickAwayListener
                onClickAway={() => {
                  if (outsideClick1) {
                    setEndDate(new Date(endDate));
                    setDisabledButton(false);
                    setOutsideClick1(false);
                  }
                }}
              >
                <DatePicker
                  value={endDate}
                  inputFormat="DD-MMM-YYYY"
                  inputProps={{ "aria-label": "Without label" }}
                  onChange={(newValue) => {
                    if (newValue && newValue.format() !== "Invalid Date") {
                      localStorage.setItem(
                        "foodReportEndDate",
                        new Date(newValue)
                      );
                      setEndDate(newValue);
                      setDisabledButton(false);
                    } else {
                      if (newValue === null) {
                        // let eDateData = new Date(
                        //   localStorage.getItem("foodReportEndDate")
                        // );
                        // setEndDate(eDateData);
                        setDisabledButton(true);
                        setOutsideClick1(true);
                      } else {
                        setDisabledButton(true);
                      }
                    }
                    setEndDateColor("#ff0000");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        input: { color: endDateColor },
                      }}
                    />
                  )}
                  PaperProps={{
                    sx: {
                      maxHeight: 350,
                      "& .MuiPickersLayout-contentWrapper": {
                        mb: 0,
                      }
                    }
                  }}
                  components={{
                    ActionBar: (props) => (
                      <TodayDateActionBar
                        onToday={() => {
                          const today = moment().startOf("day");
                          if (today && today.format() !== "Invalid Date") {
                            localStorage.setItem(
                              "foodReportEndDate",
                              new Date(today)
                            );
                            setEndDate(today);
                            setDisabledButton(false);
                            props.onAccept?.();
                            props.onClose?.();
                          } else {
                            if (today === null) {
                              // let eDateData = new Date(
                              //   localStorage.getItem("foodReportEndDate")
                              // );
                              // setEndDate(eDateData);
                              setDisabledButton(true);
                              setOutsideClick1(true);
                            } else {
                              setDisabledButton(true);
                            }
                          }
                          setEndDateColor("#ff0000");
                        }}
                      />
                    ),
                  }}
                />
              </ClickAwayListener>
            </LocalizationProvider>
          </div>

          <div className="filter-btn-wrapper">
            <Tooltip title={t("Show_month_to_date")}>
              <button
                disabled={disabledButton}
                onClick={setMTD}
                style={MtdState ? activeBtn : null}
              >
                MTD
              </button>
            </Tooltip>
            <Tooltip title={t("Show_quarter_to_date")}>
              <button
                disabled={disabledButton}
                onClick={setQTD}
                style={QtdState ? activeBtn : null}
              >
                QTD
              </button>
            </Tooltip>
            <Tooltip title={t("Show_year_to_date")}>
              <button
                disabled={disabledButton}
                onClick={setYTD}
                style={YTDState ? activeBtn : null}
              >
                YTD
              </button>
            </Tooltip>
          </div>
          <div>
            <Tooltip title={t("Refresh")}>
              <button
                className="refresh-btn"
                disabled={
                  disabledButton ||
                  getFoodOrdersDataStatus == API_STATUSES.REQUEST
                }
                onClick={handleRefresh}
              >
                <RefreshIcon color="var(--theme-text)" />
                {t("Refresh")}
              </button>
            </Tooltip>
          </div>
        </FilterHeader>
        <ChartMainWrapper>
          {/* Sales By Week Chart */}

          <div>
            <Chart onRefresh={handleChartRefresh}>
              <ChartTitle
                text={salesByDateChartData && salesByDateChartData?.title}
              />

              <ChartLegend visible={false} position="bottom" />
              <ChartSeriesDefaults
                type="column"
                labels={{
                  visible: false,
                }}
              />

              <ChartSeries>
                <ChartSeriesItem
                  name="Sales"
                  color="#080"
                  data={salesByDateChartData && salesByDateChartData?.values}
                >
                  <ChartSeriesItemTooltip
                    render={nestedTooltipRender}
                    visible={true}
                    background="#040"
                    color="white"
                  />
                </ChartSeriesItem>
              </ChartSeries>
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    template: (e) => {
                      return tempSellersTooltipRender(e);
                    },
                  }}
                  line={{
                    visible: false,
                  }}
                  axisCrossingValue={0}
                />
              </ChartValueAxis>

              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={
                    salesByDateChartData && salesByDateChartData?.labels
                  }
                  labels={{
                    rotation: -90,
                  }}
                  majorGridLines={{
                    visible: true,
                  }}
                />
              </ChartCategoryAxis>
            </Chart>
          </div>

          {/* Total Sales By Item */}

          <div>
            <Chart onRefresh={handleChartRefresh}>
              <ChartTitle
                text={t("Total_Sales_by_Item")}
                position="top"
                padding={{
                  bottom: 40,
                }}
              />
              <ChartLegend visible={false} />
              <ChartSeriesDefaults
                labels={{
                  visible: true,
                  background: "transparent",
                  render: "#= category #", //: $#= value#"
                }}
              />

              <ChartSeries>
                <ChartSeriesItem
                  type="pie"
                  data={
                    salesByItemChartData &&
                    salesByItemChartData.length !== 0 &&
                    salesByItemChartData
                  }
                  startAngle={150}
                  labels={{
                    visible: true,
                    content: labelContent,
                    background: "transparent",
                    padding: 2,
                    distance: 55,
                  }}
                >
                  <ChartSeriesItemTooltip
                    render={nestedTooltipRender}
                    visible={true}
                    background="#040"
                    color="white"
                  />
                </ChartSeriesItem>
              </ChartSeries>
            </Chart>
          </div>

          {/* Top Sellers by Total Sales */}

          <div>
            <Chart onRefresh={handleChartRefresh}>
              <ChartTitle
                text={sellersByTotalSales && sellersByTotalSales?.title}
              />

              <ChartLegend visible={false} position="bottom" />
              <ChartSeriesDefaults
                type="bar"
                labels={{
                  visible: false,
                }}
              />
              <ChartSeries>
                <ChartSeriesItem
                  name="Sales"
                  color="#080"
                  data={sellersByTotalSales && sellersByTotalSales?.values}
                >
                  <ChartSeriesItemTooltip
                    render={sellersTooltipRender}
                    visible={true}
                    background="#040"
                    color="white"
                  />
                </ChartSeriesItem>
              </ChartSeries>
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    template: (e) => {
                      return tempSellersTooltipRender(e);
                    },
                    rotation: -90,
                  }}
                  line={{
                    visible: false,
                  }}
                  axisCrossingValue={0}
                />
              </ChartValueAxis>

              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={
                    sellersByTotalSales && sellersByTotalSales?.labels
                  }
                  majorGridLines={{
                    visible: true,
                  }}
                />
              </ChartCategoryAxis>
            </Chart>
          </div>

          {/* Top Sellers by Quantity */}

          <div>
            <Chart onRefresh={handleChartRefresh}>
              <ChartTitle
                text={sellersByQuantity && sellersByQuantity?.title}
              />

              <ChartLegend visible={false} position="bottom" />
              <ChartSeriesDefaults
                type="bar"
                labels={{
                  visible: false,
                }}
              />

              <ChartSeries>
                <ChartSeriesItem
                  name="Sales"
                  color="#080"
                  data={sellersByQuantity && sellersByQuantity?.values}
                >
                  <ChartSeriesItemTooltip
                    render={quantityTooltipRender}
                    visible={true}
                    background="#040"
                    color="white"
                  />
                </ChartSeriesItem>
              </ChartSeries>
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    template: (e) => {
                      return e?.value;
                    },
                    rotation: -90,
                  }}
                  line={{
                    visible: false,
                  }}
                  axisCrossingValue={0}
                />
              </ChartValueAxis>

              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={sellersByQuantity && sellersByQuantity?.labels}
                  majorGridLines={{
                    visible: true,
                  }}
                />
              </ChartCategoryAxis>
            </Chart>
          </div>
        </ChartMainWrapper>
      </ReportContainer>
      <MobileFB>
        <FormControlLabel
          control={
            <Checkbox
              checked={isFoodEnable ? isFoodEnable : false}
              icon={<UncheckIcon />}
              checkedIcon={<CheckIcon />}
              onChange={handleOnChange}
            />
          }
          label={t("Food_&_Beverage_enabled")}
        />
      </MobileFB>
    </>
  );
}

export default FBReports;
